import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import Navbar from './components/Navbar';
import { About } from './components/About';
import { Home } from './components/Home';
import NoteState from './Context/Notes/NoteState';
import  Alert  from './components/Alert';
import Signup from './components/signup';
import Login from './components/login';
import { useState } from 'react';

function App() {

  const [alert,setAlert] = useState("hello");
  const showAlert = (message,type) =>{
    setAlert({
      msg:message,
      type:type
    })
    setTimeout(() => {
      setAlert(null);
    }, 2000);
  }
  return (
      <>
      <NoteState>
      <Router>
      <Navbar/>
      <Alert alert={alert}/>
      <div className='container mt-4'>

      <Routes>
          <Route exact path="/" element={<Home showAlert={showAlert}/>}/>
          <Route exact path="/about" element={<About/>}/>
          <Route exact path="/login" element={<Login showAlert={showAlert}/>}/>
          <Route exact path="/signup" element={<Signup showAlert={showAlert}/>}/>
      </Routes>
      </div>
        </Router>
        </NoteState>
    </>
  );
}

export default App;
